import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, Facebook, Instagram, MessageCircle } from "lucide-react";
import { SITE } from "../lib/site";

export const Footer = () => {
  return (
    <footer className="bg-brand-ink text-white pt-16 pb-8 mt-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="md:col-span-2 max-w-md">
          <div className="flex items-center gap-3 mb-4">
            {/* <div className="w-12 h-12 rounded-md bg-white/5 flex items-center justify-center overflow-hidden">
              <img src="/assets/brand/logo.jpeg" alt="Desire Vet Care" className="w-full h-full object-cover" />
            </div> */}
            <div className="leading-tight">
              <div className="font-heading font-extrabold text-xl text-brand-orange">Desire</div>
              <div className="font-heading font-bold text-[10px] tracking-[0.18em] text-white/70">VET CARE PVT. LTD.</div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed mb-5">
            {SITE.tagline}. We manufacture and supply scientifically formulated veterinary medicines for cattle, buffalo, goat, sheep & poultry across India.
          </p>
          <div className="flex items-center gap-3">
            <a href={SITE.social.facebook} aria-label="Facebook" data-testid="footer-fb" className="w-9 h-9 rounded-md border border-white/15 flex items-center justify-center hover:bg-brand-orange hover:border-brand-orange transition-colors"><Facebook size={16} /></a>
            <a href={SITE.social.instagram} aria-label="Instagram" data-testid="footer-ig" className="w-9 h-9 rounded-md border border-white/15 flex items-center justify-center hover:bg-brand-orange hover:border-brand-orange transition-colors"><Instagram size={16} /></a>
            <a href={SITE.social.whatsapp} aria-label="WhatsApp" data-testid="footer-wa" className="w-9 h-9 rounded-md border border-white/15 flex items-center justify-center hover:bg-brand-green hover:border-brand-green transition-colors"><MessageCircle size={16} /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-5 text-brand-orange">Company</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" data-testid="footer-home" className="text-white/75 hover:text-brand-orange">Home</Link></li>
            <li><Link to="/about" data-testid="footer-about" className="text-white/75 hover:text-brand-orange">About Us</Link></li>
            <li><Link to="/products" data-testid="footer-products" className="text-white/75 hover:text-brand-orange">Products</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-white/75 hover:text-brand-orange">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-5 text-brand-orange">Reach Us</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-2"><MapPin size={16} className="text-brand-orange mt-0.5 shrink-0" /> {SITE.address}</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-brand-orange shrink-0" /> <a href={`tel:${SITE.phoneRaw}`} className="hover:text-brand-orange">{SITE.phoneDisplay}</a></li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-brand-orange shrink-0" /> <a href={`mailto:${SITE.email}`} className="hover:text-brand-orange break-all">{SITE.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
        <p>© {new Date().getFullYear()} Desire Vet Care Pvt. Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
};
